<template>
  <div>
    <transition name="layout" mode="out-in">
      <component :is="layout">
        <router-view v-slot="slotProps">
          <transition name="route" mode="out-in">
            <component :is="slotProps.Component"></component>
          </transition>
        </router-view>
      </component>
    </transition>
    <!-- Global access notice (e.g. supporting user bounced off a restricted
         page). Auto-dismisses; also closable. -->
    <base-toast
      v-if="accessNotice"
      :message="accessNotice"
      type="error"
      @close="clearNotice"
    />
  </div>
</template>

<script>
import BaseToast from "./components/ui/BaseToast.vue";

const defaultLayout = "blank";

export default {
  name: "app",
  components: { BaseToast },
  data() {
    return { noticeTimer: null };
  },
  computed: {
    layout() {
      return (this.$route.meta.layout || defaultLayout) + "-layout";
    },
    didAutoLogout() {
      return this.$store.getters.didAutoLogout;
    },
    accessNotice() {
      return this.$store.getters.accessNotice;
    },
  },
  created() {
    this.clearCacheAndReload();
    this.$store.dispatch("tryLogin");
    this.bindCrossTabAuthSync();
  },
  beforeUnmount() {
    if (this._authStorageHandler) {
      window.removeEventListener("storage", this._authStorageHandler);
    }
    if (this.noticeTimer) clearTimeout(this.noticeTimer);
  },
  watch: {
    didAutoLogout(curValue, oldValue) {
      if (curValue && curValue !== oldValue) {
        this.$router.replace("/");
      }
    },
    accessNotice(msg) {
      if (this.noticeTimer) {
        clearTimeout(this.noticeTimer);
        this.noticeTimer = null;
      }
      if (msg) {
        this.noticeTimer = setTimeout(() => this.clearNotice(), 4000);
      }
    },
  },
  methods: {
    clearNotice() {
      this.$store.commit("setAccessNotice", null);
    },
    clearCacheAndReload() {
      if ("caches" in window) {
        caches.keys().then((cacheNames) => {
          cacheNames.forEach((cacheName) => {
            caches.delete(cacheName);
          });
        });
      }
    },
    bindCrossTabAuthSync() {
      // Reload this tab when a sibling tab logs in, logs out, or switches
      // user. Vuex state is per-tab and in-memory; without this, the tab
      // that wasn't touched keeps the previous user's cached state while
      // localStorage already holds the new session — the "data conflict"
      // symptom. The storage event only fires in OTHER tabs, so the tab
      // that actually logged in/out will not self-reload.
      this._authStorageHandler = (event) => {
        if (event.key !== "token") return;
        if (event.newValue === event.oldValue) return;
        window.location.reload();
      };
      window.addEventListener("storage", this._authStorageHandler);
    },
  },
};
</script>

<style lang="scss" scoped>
.route-enter-from {
  opacity: 0;
  transform: translateY(-30px);
}
.route-leave-to {
  opacity: 0;
  transform: translateY(30px);
}
.route-enter-active {
  transition: all 0.3s ease-out;
}
.route-leave-active {
  transition: all 0.3s ease-in;
}
.route-enter-to,
.route-leave-from {
  opacity: 1;
  transform: translateY(0);
}

.layout-enter-active,
.layout-leave-active {
  transition: all 0.3s;
}
.layout-enter-from,
.layout-leave-to {
  opacity: 0;
  filter: blur(0.25rem);
}
</style>
